<template>
<!-- 为趋势策略修改余额使用的mondel -->
  <div>
    <Row>
      <Modal
        v-model="m_open_modal_switch"
        :title="this.get_modal_title()"
        :loading="loading_status"
        @on-ok="set_ok"
        @on-cancel="set_cancel"
      >
        <p slot="header" class="demo-drawer-hearde">
          <Icon type="information-circled;center"></Icon>
          <span>{{ this.get_modal_title() }}</span>
        </p>
        <Row>
          <Col span="20" offset="2">
            <Form label-position="left" :label-width="160" >
              <FormItem label="币种名称" prop="asset">
                  <Input
                    v-model="m_asset"
                    clearable
                    show-word-limit
                    maxlength="20"
                    placeholder="输入币种名称"
                  ></Input>
              </FormItem>
              <FormItem label="设定数量">
                <InputNumber
                    v-model="m_balance"
                    :min="0"
                  ></InputNumber>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </Modal>
    </Row>
  </div>
</template>
<script>

export default {
  name: "flexible_render_modal_view_confirm",
  data() {
    return {
      timer: null,
      input_value:"等待最新信息",
      m_open_modal_switch:false,
      loading_status:false,
      m_asset:null,
      m_balance:0,
    }
  },
  props: {
    open_modal_switch: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
    },
    acc_id: {
      type: Number,
    },
    strategy_id: {
      type: Number,
    },
  },
  methods:{
    setTimer: function (interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
        }, interval);
      }
    },
    get_modal_title() {
      return this.title
    },
    set_cancel() {
      this.$emit("modal_click", {
        "mode":"cancel",
      })
    },
    set_ok() {
      this.$emit("modal_click", {
        "mode":"ok",
        "asset":this.m_asset,
        "balance":this.m_balance,
        "acc_id":this.acc_id,
        "strategy_id":this.strategy_id,
      })
    },
  },
  mounted: function() {
    
  },
  watch: {
    open_modal_switch(old_value) {
      // 避免直接由内部修改props的情况
      this.m_open_modal_switch = this.open_modal_switch
    },
  }
}
</script>
<style scoped>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>